import { Component, inject } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";

@Component({
  selector: "app-cyclical-home",
  templateUrl: "./cyclical-home.component.html",
  styleUrls: ["./cyclical-home.component.scss"],
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class CyclicalHomeComponent {
  private router = inject(Router);

  activeLink: string = "";

  constructor() {
    const router = this.router;

    router.events.subscribe(() => {
      this.activeLink = router.url;
    });
  }
}
